module.exports = __webpack_public_path__ + "static/elfh-ipad-477c8cbced655ac920d199c613cb8318.jpg";